import React from "react";
import "../assets/css/modal.css";
import { X } from "lucide-react";
import Form from "./Form";

const Modal = ({ modal, setModal }) => {
  return (
    <div>
      {modal === true ? (
        <div className="modal-container">
          <Form />
          <span
            className="close"
            onClick={() => {
              setModal(false);
            }}
          >
            <X />
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Modal;
